// Builder configuration models

export interface BuilderStepConfig {
  id: string;
  title: string;
  description: string;
  component: string;
  isCompleted: boolean;
  isRequired: boolean;
}

export const BUILDER_STEPS: readonly BuilderStepConfig[] = [
  {
    id: 'travel-info',
    title: 'Travel Information',
    description: 'Tell us about your trip',
    component: 'TravelInfoStep',
    isCompleted: false,
    isRequired: true
  },
  {
    id: 'day-builder',
    title: 'Day Builder',
    description: 'Plan your daily activities',
    component: 'DayBuilderStep',
    isCompleted: false,
    isRequired: true
  },
  {
    id: 'checkout',
    title: 'Checkout',
    description: 'Review and confirm your itinerary',
    component: 'CheckoutStep',
    isCompleted: false,
    isRequired: true
  }
] as const;

export const TOTAL_STEPS = BUILDER_STEPS.length;
